import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/zoom-in-icon.png'
import _imports_1 from '@/assets/icons/add-stage.png'


const _withScopeId = n => (_pushScopeId("data-v-c6ee4410"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "generalContainer" }
const _hoisted_2 = { class: "ratingStars" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Califica tu experiencia", -1))
const _hoisted_4 = {
  key: 0,
  class: "documentsContainer__survey"
}
const _hoisted_5 = { class: "innerContainer" }
const _hoisted_6 = { class: "documentsContainer" }
const _hoisted_7 = { class: "documentsContainer__description" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_9 = { class: "documentsContainer__documents" }
const _hoisted_10 = ["href"]
const _hoisted_11 = ["alt"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_13 = {
  key: 0,
  class: "documentsContainer__survey"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_star_rating = _resolveComponent("star-rating")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!
  const _component_HeaderApp = _resolveComponent("HeaderApp")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ModalComponent, {
      open: _ctx.openSurvey,
      onCloseModal: _ctx.closeSurveyModal
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_star_rating, {
            "border-width": 4,
            "border-color": "#d8d8d8",
            "rounded-corners": true,
            "star-points": [23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17],
            increment: 1,
            showRating: false,
            rating: _ctx.surveyScore,
            "onUpdate:rating": [
              _cache[0] || (_cache[0] = ($event: any) => ((_ctx.surveyScore) = $event)),
              _ctx.updatedRating
            ]
          }, null, 8, ["rating", "onUpdate:rating"]),
          _createElementVNode("p", null, [
            _createElementVNode("b", null, _toDisplayString(_ctx.surveyScore), 1)
          ]),
          _withDirectives(_createElementVNode("textarea", {
            class: "ratingFeedback",
            name: "",
            id: "",
            cols: "30",
            rows: "10",
            placeholder: "Describe tu experiencia con nostros",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.surveyFeedback) = $event))
          }, null, 512), [
            [_vModelText, _ctx.surveyFeedback]
          ]),
          (_ctx.isCompleted)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.saveProductSurvey && _ctx.saveProductSurvey(...args)))
                }, " Guardar Calificación ")
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["open", "onCloseModal"]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_HeaderApp, {
          "header-type": 'products',
          products: _ctx.products
        }, null, 8, ["products"]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("h2", null, "Documentos Finales del Producto: " + _toDisplayString(_ctx.displayedName), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.displayedDescription), 1),
          _hoisted_8,
          _createElementVNode("p", null, _toDisplayString(_ctx.displayedInformation), 1),
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productDocuments, (document, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createElementVNode("a", {
                  href: document.url,
                  target: "_blank"
                }, [
                  _createElementVNode("button", null, [
                    _createTextVNode(_toDisplayString(document.name) + " ", 1),
                    _createElementVNode("img", {
                      src: _imports_0,
                      alt: document.name
                    }, null, 8, _hoisted_11)
                  ])
                ], 8, _hoisted_10)
              ]))
            }), 128))
          ]),
          _createElementVNode("p", {
            class: "documentsContainer__share",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.getShareProductLink && _ctx.getShareProductLink(...args)))
          }, [
            _createTextVNode(" Comparte este producto: "),
            _hoisted_12
          ]),
          (_ctx.isCompleted)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openSurveyModal && _ctx.openSurveyModal(...args)))
                }, " Califica tu experiencia ")
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}